declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackCartProductProtectionWhatIsCoveredClose = (data, pageType = 'cart') => {
  const event = 'product_protection_whats_covered_drawer_close'

  const logData = {
    event,
    page: pageType,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackCartProductProtectionWhatIsCoveredClose
